export default __webpack_public_path__ + "assets/visibility.c5405e8d.svg";